// Generated by scripts/sportsbook_history/generate.mjs
const NEUTRAL_WAITING = Object.freeze({ label: '대기', color: '#888', background: '#f0f0f0' });
const CONFIRMED_WAITING = Object.freeze({ label: '대기', color: '#b45309', background: '#fef3c7' });
const WON = Object.freeze({ label: '적중', color: '#10b981', background: '#d1fae5' });
const LOST = Object.freeze({ label: '미적중', color: '#ef4444', background: '#fee2e2' });
const HALF_WON = Object.freeze({ label: '반적중', color: '#2563eb', background: '#dbeafe' });
const HALF_LOST = Object.freeze({ label: '반미적중', color: '#d97706', background: '#fef3c7' });
const VOID = Object.freeze({ label: '무효', color: '#8b5cf6', background: '#f3e8ff' });
const REFUNDED = Object.freeze({ label: '무효', color: '#6b7280', background: '#f3f4f6' });
const PUSH = Object.freeze({ label: '적특', color: '#d97706', background: '#fef3c7' });
const CANCELLED = Object.freeze({ label: '취소', color: '#dc2626', background: '#fee2e2' });
const REJECTED = Object.freeze({ label: '거절', color: '#dc2626', background: '#fee2e2' });
const FAILED = Object.freeze({ label: '실패', color: '#dc2626', background: '#fee2e2' });
const UNKNOWN = Object.freeze({ label: '상태 확인', color: '#6b7280', background: '#f3f4f6' });

const DISPLAY_BY_STATUS = Object.freeze({
  PENDING: NEUTRAL_WAITING,
  OPEN: NEUTRAL_WAITING,
  ACCEPTED: CONFIRMED_WAITING,
  CONFIRMED: CONFIRMED_WAITING,
  WON_PENDING: CONFIRMED_WAITING,
  WIN: WON,
  WON,
  LOSE: LOST,
  LOSS: LOST,
  LOST,
  HALF_WIN: HALF_WON,
  HALF_WON,
  HALF_LOSE: HALF_LOST,
  HALF_LOSS: HALF_LOST,
  HALF_LOST,
  VOID,
  REFUND: REFUNDED,
  REFUNDED,
  PUSH,
  CANCEL: CANCELLED,
  CANCELLED,
  CANCELED: CANCELLED,
  REJECTED,
  FAILED,
});

export const getSportsbookHistorySelectionStatusDisplay = (status) => {
  const normalizedStatus = String(status ?? '').trim().toUpperCase();
  return DISPLAY_BY_STATUS[normalizedStatus] || UNKNOWN;
};
